import React from 'react';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import {
  Button,
  FaSvg,
  useModal,
  Modal,
  ModalContent,
  Alert,
  notification,
} from '@zen-common/components-base';
import usePreventAction from '../../../utils/usePreventAction';
import CancelModalProcess from './CancelModalProcess';

export default function CancelButton({ order, ...props }) {
  const { show, hide } = useModal();
  const { preventAction } = usePreventAction();

  function handleCancel() {
    hide();
  }
  function handleError(error) {
    show(() => (
      <Alert type={Alert.TYPE.ERROR} onDismiss={hide} title="Error">
        {error.message}
      </Alert>
    ));
  }
  function handleSuccess() {
    notification('Order canceled successfully', {
      type: notification.TYPE.SUCCESS,
    });
    hide();
  }

  const handleClick = async () => {
    if (preventAction()) return;

    show(() => (
      <Modal>
        <ModalContent>
          <CancelModalProcess
            onCancel={handleCancel}
            onError={handleError}
            onSuccess={handleSuccess}
            order={order}
          />
        </ModalContent>
      </Modal>
    ));
  };

  return (
    <Button
      bg="secondary"
      width="90px"
      borderRadius="1"
      fontSize="sm"
      px="xs"
      sizeVariant="small"
      {...props}
      onClick={handleClick}
    >
      Cancel <FaSvg ml="xxs" color="label" icon={faTimesCircle} />
    </Button>
  );
}
